import React from 'react';
import noop from 'lodash/noop';
import { AnalyticsSource, AnalyticsSubject } from '@atlassian/jira-analytics-web-react/src';
import AppBase from '@atlassian/jira-app-base';
import AppStyle from '@atlassian/jira-common-components-app-style';
import { ReportErrors } from '@atlassian/jira-errors-handling';
import { MODAL } from '@atlassian/jira-product-analytics-bridge';
import { useIsAdmin } from '@atlassian/jira-tenant-context-controller';

import type { AppProps } from './model';
import View from './view';

function EditFilterModal(props: Partial<AppProps>) {
	const isAdmin = useIsAdmin();

	return (
		<AppBase hasErrorBoundary={false}>
			<ReportErrors id="unhandled" packageName="jiraEditFiltersModal" teamName="jira-cosmos">
				<AppStyle>
					<View isAdmin={isAdmin} {...props} />
				</AppStyle>
			</ReportErrors>
		</AppBase>
	);
}

export type { EditFilterModal };

EditFilterModal.defaultProps = {
	onEdited: noop,
	onEditFailed: noop,
	onCancel: noop,
};

export default AnalyticsSource('editFilter', MODAL)(AnalyticsSubject('filter')(EditFilterModal));
